import userImportApi from "@/api/userImport";
import userApi from "@/api/user";

export default {
  actions: {
    clearImportList({ commit }) {
      commit("importRequestIdIncrement");
      commit("importListSet", []);
    },
    async importUserListByServiceArea({ commit, state }, serviceAreaId) {
      commit("importRequestIdIncrement");
      const requestId = state.import.requestId;
      commit("importListLoadingSet", true);
      try {
        const list = await userImportApi.importUserListByServiceArea(serviceAreaId);
        if (state.import.requestId !== requestId) return;
        commit("importListSet", list);
      } catch (e) {
        if (state.import.requestId !== requestId) return;
        commit("importListSet", []);
        throw e;
      } finally {
        if (state.import.requestId === requestId) {
          commit("importListLoadingSet", false);
        }
      }
    },
    async fetchList({ commit }, searchParamList) {
      commit("setLoadingList", true);
      const list = await userApi.search(searchParamList);
      commit("setList", list);
    },
    async fetchListByServiceArea({ commit }, serviceAreaId) {
      commit("setLoadingList", true);
      const list = await userApi.search([{ comparator: "=", name: "serviceAreaId", value: serviceAreaId }]);
      commit("setList", list);
    },
    async import(context, { id, serviceAreaId }) {
      await userApi.import(id, serviceAreaId);
    },
    async update(context, user) {
      await userApi.update(user);
    },
  },
  mutations: {
    importRequestIdIncrement(state) {
      state.import.requestId += 1;
    },
    importListSet(state, list) {
      state.import.list = list;
      state.import.loadingList = false;
    },
    importListLoadingSet(state, isLoading) {
      state.import.loadingList = isLoading;
    },
    setEdit(state, user) {
      state.edit = user;
    },
    setList(state, list) {
      state.list = list;
      state.loadingList = false;
    },
    setLoadingList(state, isLoading) {
      state.loadingList = isLoading;
    },
  },
  namespaced: true,
  state: {
    edit: {},
    import: {
      loadingList: false,
      list: [],
      requestId: 0,
    },
    list: [],
    loadingList: false,
  },
};
